import { render, staticRenderFns } from "./CrudWorkDetails.vue?vue&type=template&id=af728fb4&scoped=true"
import script from "./CrudWorkDetails.vue?vue&type=script&lang=ts"
export * from "./CrudWorkDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudWorkDetails.vue?vue&type=style&index=0&id=af728fb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af728fb4",
  null
  
)

export default component.exports